// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  BASE_API_URL: '/api/',
  IMAGE_BASE_URL: '//',
  GAPI_CLIENT_ID: '108837013661336610699',
  // API_URL: 'https://sheets.googleapis.com/v4/spreadsheets/',
  // CLIENT_ID: 'examplesheetgoogle@flash-yen-338005.iam.gserviceaccount.com',
  // SCOPE: 'https://www.googleapis.com/auth/spreadsheets.readonly',
  // SHEET_ID: '15fYZybyaqM75RPa-XkiXLjUFgUMoPwYpggLJT3NjvYQ',
  production: false,

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
